module.exports = __webpack_public_path__ + "static/media/material_master_lite.94f3d121.csv";